// Runtime polyfill: ensure `process.env.SOME_KEY` works in the browser even
// when Vite's AST-aware `define` misses (e.g. bracket notation, files outside
// its transform graph). The dev server populates __AIIA_PROCESS_ENV__ via
// `define` in vite.config.ts. In production builds the same value is baked.
declare global {
  interface Window {
    process?: { env?: Record<string, string> };
  }
  // eslint-disable-next-line no-var
  var __AIIA_PROCESS_ENV__: Record<string, string> | undefined;
}

if (typeof window !== "undefined") {
  const baked = (globalThis as any).__AIIA_PROCESS_ENV__ ?? {};
  window.process ??= {};
  window.process.env ??= {};
  Object.assign(window.process.env, baked, { NODE_ENV: import.meta.env.MODE });
}

import "@fontsource/manrope/400.css";
import "@fontsource/manrope/500.css";
import "@fontsource/manrope/600.css";
import "@fontsource/manrope/700.css";
import "../app/globals.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { router } from "./router";
import { reloadForNewBuild } from "./stale-build";
import { initUiLanguage } from "../lib/i18n";

// A page file from the previous build is gone after a deploy: reload to get
// the new build instead of failing the navigation (BUG-203).
window.addEventListener("vite:preloadError", (event) => {
  if (reloadForNewBuild()) event.preventDefault();
});

document.body.style.setProperty("--font-app-ui", "'Manrope', sans-serif");

// The portal language loads before the first render, so a German recruiter
// never sees the English page flash first (docs/PORTAL_I18N.md).
initUiLanguage().finally(() => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  );
});
